import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { AlertTriangle } from "lucide-react";

/** A failed fetch gets a message and a Retry, never an empty state or an endless skeleton. */
export function QueryError({
  message,
  onRetry,
  className,
}: {
  message: string;
  onRetry?: () => void;
  className?: string;
}) {
  return (
    <div
      className={cn(
        "mt-4 flex items-center gap-3 rounded-md border border-destructive/40 bg-destructive/5 px-4 py-3 text-sm",
        className,
      )}
      role="alert"
      data-testid="query-error"
    >
      <AlertTriangle className="w-4 h-4 shrink-0 text-destructive" />
      <span className="flex-1">{message}</span>
      {onRetry && (
        <Button size="sm" variant="outline" onClick={onRetry}>
          Retry
        </Button>
      )}
    </div>
  );
}

/** The message for a failed admin query, with the server's reason when it gave one. */
export function queryErrorMessage(what: string, error: unknown): string {
  const detail = error instanceof Error && error.message ? `: ${error.message}` : "";
  return `Couldn't load ${what}${detail}`;
}
